import { render } from "./Colxx.vue?vue&type=template&id=a5a5fbf6"
import script from "./Colxx.vue?vue&type=script&lang=js"
export * from "./Colxx.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__